// @mui icons
import Icon from "@mui/material/Icon";

// Pages
import Balances from "app/balances";
import UserProfile from "./user/profile";
// import P2PMarketOverview from "./p2p/overview";
import BankAccounts from "./bank_accounts";
import VirtualCards from "./cards";
import Beneficiaries from "./beneficiaries";
import MyPayouts from "./transfers/payouts";
// import P2POrders from "./p2p/fx/orders";
// import MainBalance from "./balances/main";
// import DwOffers from "./p2p/ewallets";
import CreateSwap from "./swaps";
import P2PIndex from "./p2p";
import GiftCards from "./gift_cards";
// import SwitchIndex from "./switch";
import EChecks from "./echecks";
import PayLinks from "./pay_links";
import AleroSwitch from "./switch/switch";
import AirtimeIndex from "./airtime";

const routes = [
  {
    type: "collapse",
    name: "Dashboard",
    key: "dashboard",
    icon: <Icon fontSize="small">dashboard</Icon>,
    route: "/dashboard",
    component: <Balances />,
    // component: <MainBalance />,
    secure: true,
  },
  // {
  //   type: "collapse",
  //   name: "Balances",
  //   key: "balances",
  //   icon: <Icon fontSize="small">wallet</Icon>,
  //   route: "/balances",
  //   component: <Balances />,
  //   secure: true,
  // },
  {
    type: "collapse",
    name: "Cards",
    key: "cards",
    icon: <Icon fontSize="small">credit_card</Icon>,
    route: "/cards",
    component: <VirtualCards />,
    secure: true,
  },
  {
    type: "collapse",
    name: "Bank Accounts",
    key: "bank-accounts",
    icon: <Icon fontSize="small">account_balance</Icon>,
    route: "/bank-accounts",
    component: <BankAccounts />,
    secure: true,
  },
  {
    type: "collapse",
    name: "Instant Conversion",
    key: "convert",
    icon: <Icon fontSize="small">currency_exchange</Icon>,
    route: "/convert",
    component: <CreateSwap />,
    secure: true,
  },
  {
    type: "collapse",
    name: "Transfers",
    key: "transfers",
    icon: <Icon fontSize="small">send</Icon>,
    route: "/transfers",
    component: <MyPayouts />,
    secure: true,
  },
  {
    type: "collapse",
    name: "Pay Links",
    key: "pay-links",
    icon: <Icon fontSize="small">receipt</Icon>,
    route: "/pay-links",
    component: <PayLinks />,
    secure: true,
  },
  {
    type: "collapse",
    name: "E-Cheques",
    key: "e-cheques",
    icon: <Icon fontSize="small">note</Icon>,
    route: "/e-cheques",
    component: <EChecks />,
    secure: true,
  },
  {
    type: "divider",
    name: "Divider",
  },
  {
    type: "collapse",
    name: "Airtime & Data",
    key: "airtime",
    icon: <Icon fontSize="small">cell_tower</Icon>,
    route: "/airtime",
    component: <AirtimeIndex />,
    secure: true,
  },
  {
    type: "collapse",
    name: "Switch",
    key: "switch",
    icon: <Icon fontSize="small">paid</Icon>,
    route: "/switch",
    component: <AleroSwitch />,
    secure: true,
  },
  {
    type: "collapse",
    name: "P2P Marketplace",
    key: "p2p",
    icon: <Icon fontSize="small">hub</Icon>,
    route: "/p2p",
    component: <P2PIndex />,
    secure: true,
  },
  {
    type: "collapse",
    name: "Gift Cards",
    key: "giftcards",
    icon: <Icon fontSize="small">redeem</Icon>,
    route: "/giftcards",
    component: <GiftCards />,
    secure: true,
  },
  {
    type: "divider",
    name: "Divider",
  },
  {
    type: "collapse",
    name: "Profile",
    key: "profile",
    icon: <Icon fontSize="small">person</Icon>,
    route: "/profile",
    component: <UserProfile />,
    secure: true,
  },
  {
    type: "collapse",
    name: "Beneficiaries",
    key: "beneficiaries",
    icon: <Icon fontSize="small">group</Icon>,
    route: "/beneficiaries",
    component: <Beneficiaries />,
    secure: true,
  },
];

export default routes;
